export default "__VITE_PUBLIC_ASSET__01d7487b__"